import { useAuth } from 'contexts/auth';
import { CustomerSubscriptionStatus } from 'interfaces/customer';
import { useEffect } from 'react';

type Output = {
  isLoginRequired: boolean;
  hasSubscription: boolean;
};

/**
 * Check if user has an at least one active subscription
 */
const useHasSubscription = (): Output => {
  /**
   * @TODO : customer object might not be unreliable due to error and we might have to rely on Ninetailed
   *  https://petsdeli.atlassian.net/browse/PT-4077
   */
  const { isUserAuthenticated, customer, fetchCustomer } = useAuth();

  /**
   * Refetch customer to get updated status of subscription
   */
  useEffect(() => {
    fetchCustomer();
  }, [fetchCustomer]);

  return {
    isLoginRequired: !isUserAuthenticated,
    hasSubscription: !!(
      customer &&
      customer.subscriptionStatus === CustomerSubscriptionStatus.Active
    ),
  };
};

export default useHasSubscription;
